import * as React from 'react'
import { useCallback, useState } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { INotification } from '@user/store/notifications/typings'
import { toggleNotification } from '@user/store/notifications/api'
import { NotificationCard } from '.'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'

type Props = {
  notification: INotification
}

export function PayOverTimeCompletedNotification(props: Props) {
  const { notification } = props

  const dispatch = useAppDispatch()

  const [loading, setLoading] = useState(false)
  const onChange = useCallback(async () => {
    setLoading(true)
    await dispatch(toggleNotification(notification.id))
    setLoading(false)
  }, [dispatch, notification.id])

  return (
    <>
      <NotificationCard
        type="Customer"
        name="Pay Over Time Application Completed"
        helperText={notification.helperText}
        bottomContent={
          <FormControlLabel
            label="Off/On"
            disabled={loading}
            control={
              <Switch checked={notification.isEnabled} onChange={onChange} />
            }
          />
        }
      />
    </>
  )
}
